import React, { useState } from "react";
import Axios from "axios";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);

  function handleResponse(response) {
    setResults(response.data[0]);
  }

  function handleDictionaryResponse(response) {
    setPhotos(response.data.photos);
  }

  function search(event) {
    event.preventDefault();

    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    Axios.get(apiUrl).then(handleResponse);

    let pexelsApiKey =
      "xLGap2TKyVEh3RPuEeIQSd2GQ0pA1k4ebyOxPDTLcvdTCVzr6YQUCGBv";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
    let headers = { Authorization: pexelsApiKey };
    Axios.get(pexelsApiUrl, { headers: headers }).then(
      handleDictionaryResponse,
    );
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  return (
    <div className="Dictionary">
      <section>
        <form onSubmit={search}>
          <input
            type="search"
            placeholder="Word..."
            onChange={handleKeywordChange}
            autoFocus={true}
          />
        </form>
      </section>
      <Results results={results} />
      <Photos photos={photos} />
    </div>
  );
}
